import { memo } from 'react'

export const CrewDivider = memo(() => (
  // 表示領域内で両端に余白を持たせるためpx-2を指定する
  <div className="px-2">
    <div className="h-0 border-b crew-border-gray"></div>
  </div>
))
